import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  FETCH_PENALTY_FEES: 'FETCH_PENALTY_FEES',
  FETCH_PENALTY_FEE_BY_ID: 'FETCH_PENALTY_FEE_BY_ID',
  STORNO_PENALTY_FEE: 'STORNO_PENALTY_FEE',
};

export default {
    fetchPenaltyFees: options => {
        return apiClient.get(`/penalty-fee?${createQueryString(options)}`, {
        apiCallId: apiCallIds.FETCH_PENALTY_FEES,
        });
    },
  
    fetchPenaltyFeesByLoanId: loanId => {
        return apiClient.get(`/penalty-fee/${loanId}`, {
            apiCallId: apiCallIds.FETCH_PENALTY_FEES,
        });
    },

    stornoPenaltyFee: feeId => {
        return apiClient.delete(`/penalty-fee/${feeId}`, {
            apiCallId: apiCallIds.STORNO_PENALTY_FEE,
        });
    }
};



// WEBPACK FOOTER //
// ./src/features/penalty-fee/api/index.js